var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    })},[_c('a-switch',{on:{"change":_vm.checkedChange},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"10px"}},[_vm._v("是否开启会员协议")])],1),_vm._v(" "),_c('a-layout-content',{staticStyle:{"margin":"0 16px"}},[_c('div',{style:({ padding: '24px', background: '#fff', minHeight: '360px' })},[_c('membershipAgreementContent',{ref:"aaa",attrs:{"formInline":_vm.formInline}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108ca792","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemManagement/membershipAgreement/membershipAgreementHome.vue
// module id = null
// module chunks = 